import { createSlice } from "@reduxjs/toolkit";
export interface BusinessLeaderDashboardSlice {
  selectedSharedUidBui: [];
  selectedStartDate: string;
  selectedEndDate: string;
  selectedPeriod: string;
  selectedDimensions: [];
  selectedType: string;
  selectedInterval: string;
  selectedDaysLeftForPeriod: string;
  selectedAll: boolean;
  dateChangeClicked: string;
  websites: [];
  previousMonthQueryData: null;
  lastTwoWeeksQueryData: null;
  recentFetchedForWorkspace: string | null;
  brandsFetchedKey: string | null;
  dimensionsMobile?: any;
  budgetDataListMobile?: any;
  filteredRecordsForBudgetMobile?: any;
  isLoadingMobileBizLeader?: boolean;
  hasDataFetchedForBudgetMobile?: boolean;
  selectedBrandForBudget?: string | null;
  sortForBudget?: {
    keytoSort: "qftd";
    direction: "asc" | "desc";
    label: "QFTD";
  };
  selectedStartDateForBudget?: string;
  selectedEndDateForBudget?: string;
  conversionLastTwoWeeksQueryData: null;
  conversionFetchedForWorkspace: null;
  keywordsFetchedForWorkspace: null;
  keywordsFetchedKey: string | null;
  keywordsQueryData: null;
  brandPerformanceData: any;
  brandPerformanceLastRunData: any;
  targetVsActualPR: null;
  kpiFetchedKey: string | null;
  websiteData: any;
  loadingWebsiteData?: boolean;
}

const initialState: BusinessLeaderDashboardSlice = {
  selectedSharedUidBui: [],
  selectedStartDate: "",
  selectedEndDate: "",
  selectedPeriod: "",
  selectedDimensions: [],
  selectedType: "site",
  selectedInterval: "",
  selectedDaysLeftForPeriod: "",
  selectedAll: false,
  dateChangeClicked: "",
  websites: [],
  previousMonthQueryData: null,
  lastTwoWeeksQueryData: null,
  recentFetchedForWorkspace: null,
  brandsFetchedKey: null,
  dimensionsMobile: null,
  budgetDataListMobile: [],
  filteredRecordsForBudgetMobile: [],
  hasDataFetchedForBudgetMobile: false,
  isLoadingMobileBizLeader: false,
  selectedBrandForBudget: "",
  sortForBudget: {
    keytoSort: "qftd",
    direction: "asc",
    label: "QFTD",
  },
  selectedStartDateForBudget: "",
  selectedEndDateForBudget: "",
  conversionLastTwoWeeksQueryData: null,
  conversionFetchedForWorkspace: null,
  keywordsFetchedForWorkspace: null,
  keywordsFetchedKey: null,
  keywordsQueryData: null,
  brandPerformanceData: null,
  brandPerformanceLastRunData: null,
  targetVsActualPR: null,
  kpiFetchedKey: null,
  websiteData: null,
  loadingWebsiteData: false,
};

const businessLeaderDashboardSlice = createSlice({
  name: "businessLeaderDashboard",
  initialState,
  reducers: {
    setSelectedSharedUidBui: (state, action) => {
      state.selectedSharedUidBui = action.payload;
    },
    setStartDate: (state, action) => {
      state.selectedStartDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.selectedEndDate = action.payload;
    },
    setSelectedPriode: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setselectedDimensione: (state, action) => {
      state.selectedDimensions = action.payload;
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
    },
    setSelectedInterval: (state, action) => {
      state.selectedInterval = action.payload;
    },
    setSelectedDaysLeftForPeriod: (state, action) => {
      state.selectedDaysLeftForPeriod = action.payload;
    },
    setSelectedAll: (state, action) => {
      state.selectedAll = action.payload;
    },
    setDateChangeClicked: (state, action) => {
      state.dateChangeClicked = action.payload;
    },
    setWebsites: (state, action) => {
      state.websites = action.payload;
    },
    setPreviousMonthQueryData: (state, action) => {
      state.previousMonthQueryData = action.payload;
    },
    setLastTwoWeeksQueryData: (state, action) => {
      state.lastTwoWeeksQueryData = action.payload;
    },
    setRecentFetchedForWorkspace: (state, action) => {
      state.recentFetchedForWorkspace = action.payload;
    },
    setBrandsFetchedKey: (state, action) => {
      state.brandsFetchedKey = action.payload;
    },
    setDimensionsMobile: (state, action) => {
      state.dimensionsMobile = action.payload;
    },
    setBudgetDataListMobile: (state, action) => {
      state.budgetDataListMobile = action.payload;
    },
    setSelectedBrandForBudget: (state, action) => {
      state.selectedBrandForBudget = action.payload;
    },
    setSortForBudget: (state, action) => {
      state.sortForBudget = action.payload;
    },
    setSelectedStartDateForBudget: (state, action) => {
      state.selectedStartDateForBudget = action.payload;
    },
    setSelectedEndDateForBudget: (state, action) => {
      state.selectedEndDateForBudget = action.payload;
    },
    setConversionLastTwoWeeksQueryData: (state, action) => {
      state.conversionLastTwoWeeksQueryData = action.payload;
    },
    setConversionFetchedForWorkspace: (state, action) => {
      state.conversionFetchedForWorkspace = action.payload;
    },
    setHasDataFetchedForBudgetMobile: (state, action) => {
      state.hasDataFetchedForBudgetMobile = action.payload;
    },
    setKeywordsFetchedForWorkspace: (state, action) => {
      state.keywordsFetchedForWorkspace = action.payload;
    },
    setKeywordsFetchedKey: (state, action) => {
      state.keywordsFetchedKey = action.payload;
    },
    setKeywordsQueryData: (state, action) => {
      state.keywordsQueryData = action.payload;
    },
    setBrandPerformanceData: (state, action) => {
      state.brandPerformanceData = action.payload;
    },
    setBrandPerformanceLastRunData: (state, action) => {
      state.brandPerformanceLastRunData = action.payload;
    },
    setTargetVsActualPR: (state, action) => {
      state.targetVsActualPR = action.payload;
    },
    setKpiFetchedKey: (state, action) => {
      state.kpiFetchedKey = action.payload;
    },

    setWebsiteData: (state, action) => {
      state.websiteData = action.payload;
    },
    setLoadingWebsiteData: (state, action) => {
      state.loadingWebsiteData = action.payload;
    },

    setIsLoadingMobileBizLeader: (state, action) => {
      state.isLoadingMobileBizLeader = action.payload;
    },
    setFilteredRecordsForBudgetMobile: (state, action) => {
      state.filteredRecordsForBudgetMobile = action.payload;
    },
    resetBusinessLeaderDashboard: () => initialState,
  },
});

export const {
  setSelectedSharedUidBui,
  setStartDate,
  setEndDate,
  setSelectedPriode,
  setselectedDimensione,
  setSelectedType,
  setSelectedInterval,
  setSelectedDaysLeftForPeriod,
  setSelectedAll,
  setDateChangeClicked,
  setWebsites,
  setPreviousMonthQueryData,
  setLastTwoWeeksQueryData,
  setRecentFetchedForWorkspace,
  setBrandsFetchedKey,
  setDimensionsMobile,
  setBudgetDataListMobile,
  setSelectedBrandForBudget,
  setSortForBudget,
  setSelectedStartDateForBudget,
  setHasDataFetchedForBudgetMobile,
  setSelectedEndDateForBudget,
  setConversionLastTwoWeeksQueryData,
  setConversionFetchedForWorkspace,
  setKeywordsFetchedForWorkspace,
  setKeywordsFetchedKey,
  setKeywordsQueryData,
  setBrandPerformanceData,
  setBrandPerformanceLastRunData,
  setTargetVsActualPR,
  setKpiFetchedKey,
  setWebsiteData,
  setLoadingWebsiteData,
  setIsLoadingMobileBizLeader,
  setFilteredRecordsForBudgetMobile,
  resetBusinessLeaderDashboard,
} = businessLeaderDashboardSlice.actions;

export default businessLeaderDashboardSlice.reducer;
